<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading && listView" class="w-full">

    <div *ngIf="tab === 'distribution-center'">
        <p class="font-[500] text-[#030308] dark:text-white whitespace-nowrap">{{ regCode }} {{
            selectedCenterName }}</p>
    </div>

    <button
        class="bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 mr-5 mt-2 mb-1 text-lg flex items-center"
        (click)="downloadTemplate1()">
        <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
        <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
        {{ isDownloading ? " Downloading..." : " Download" }}
    </button>

    <div class="flex flex-row flex-nowrap max-[1024px]:flex-wrap items-center justify-between gap-4 mt-2">
        <div class="flex-shrink-0">
            <p class=" dark:text-white whitespace-nowrap">All ({{ totalItems < 10 ? ('0' + totalItems) :
                    totalItems }})</p>
        </div>
        <div class="flex flex-row flex-nowrap max-[1024px]:flex-wrap items-center justify-end gap-5 flex-1 min-w-0">
            <div class="relative w-24 flex-shrink-0 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectType" class="hidden" (change)="filterType()">
                    <option value="" selected disabled>Type</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleTypeDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectType || 'Type' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectType" (click)="cancelType($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isTypeDropdownOpen || !selectType"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isTypeDropdownOpen"
                                [class.fa-angle-up]="isTypeDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isTypeDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of typeDropdownOptions" (click)="selectTypeOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="relative w-32 flex-shrink-0 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectTimeSlot" class="hidden" (change)="filterTimeSlot()">
                    <option value="" selected disabled>TimeSlot</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleTimeSlotDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectTimeSlot || 'TimeSlot' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectTimeSlot" (click)="cancelTimeSlot($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isTimeSlotDropdownOpen || !selectTimeSlot"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isTimeSlotDropdownOpen"
                                [class.fa-angle-up]="isTimeSlotDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isTimeSlotDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of timeSlotDropdownOptions" (click)="selectTimeSlotOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>


            <div class="relative w-28 flex-shrink-0 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectRow" class="hidden" (change)="filterRow()">
                    <option value="" selected disabled>Type</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleRowDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectRow || 'Row' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectRow" (click)="cancelRow($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isRowDropdownOpen || !selectRow"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isRowDropdownOpen" [class.fa-angle-up]="isRowDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isRowDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of rowDropdownOptions" (click)="selectRowOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">Row {{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="relative w-28 flex-shrink-0 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                    <option value="" selected disabled>Status</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300" value="Late">
                        Late</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="On Time">
                        On Time</option>
                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleStatusDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectStatus || 'Status' }}</span>
                        <div class="flex items-center">
                            <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>
                            <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isStatusDropdownOpen"
                                [class.fa-angle-up]="isStatusDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isStatusDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of statusDropdownOptions" (click)="selectStatusOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="relative w-32 flex-shrink-0">
                <app-custom-datepicker [placeholder]="'Date'" [selectedDate]="selectedDate"
                    (dateChange)="onDateChange($event)"></app-custom-datepicker>
            </div>

            <div
                class="flex items-center rounded-full px-4 py-2 flex-1 min-w-32 max-[1024px]:min-w-48 max-w-xs bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search by Order ID.." title="Search by Order ID" [(ngModel)]="searchText"
                    (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                    class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button *ngIf="searchText" type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

        </div>
    </div>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
        <p class="text-[#494949] my-6 dark:text-white">---No orders found--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>


    <div *ngIf="hasData"
        class="isolate mt-5 overflow-auto max-h-[max(390px,calc(100vh-440px))] border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full min-w-max divide-y-2">
            <thead class="sticky top-0 z-20 bg-white text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                <tr>
                    <th class="sticky left-0 bg-white dark:bg-[#0F0F0F] w-20 min-w-20 px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">No</th>
                    <th class="sticky left-20 bg-white dark:bg-[#0F0F0F] w-44 min-w-44 px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Order ID</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Type</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Assigned Row</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">QC Done By</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Delivery Time Slot</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Out Time</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Status</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Details</th>

                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr *ngFor="let item of ordersArr let i = index">
                    <!-- <tr *ngFor="let item of complainArr"> -->
                    <td class="sticky left-0 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">
                        {{ (i + 1) < 10 ? ('0' + (i + 1)) : (i + 1) }} </td>
                    <td class="sticky left-20 z-10 bg-white dark:bg-[#1D1D1F] px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5] break-all">{{item.invNo}}</td>
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">{{item.delivaryMethod}}</td>
                    <td class="px-6 py-4 font-medium  text-left  text-gray-900 dark:text-[#C5C5C5]">Row
                        {{item.rowIndex}}</td>
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">
                        {{item.packBy || '----' }}
                    </td>
                    <td class="px-6 py-4 font-medium" [ngClass]="{
                        'text-[#606060] dark:text-[#606060]': (item.deliveryPeriod === 'On Time' && item.scheduleDateStatus === 'Not Passed' ),
                        'text-[#000000] dark:text-[#C5C5C5]': (item.deliveryPeriod === 'On Time' && item.scheduleDateStatus !== 'Not Passed' || item.deliveryPeriod === 'Late' || item.deliveryPeriod === 'Later')
                    }">{{ getDisplayDate(item.sheduleDate) }} {{ removeWithin(item.sheduleTime) }}</td>

                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">
                        {{ item.packTime | date: 'hh.mm a' }}
                    </td>
                    <td class="px-6 py-3">

                        <div class="flex font-medium items-left justify-start h-full">
                            <span *ngIf="item.deliveryPeriod ==='On Time'" class="text-[#415CFF] ">
                                On Time
                            </span>

                            <span *ngIf="item.deliveryPeriod ==='Late'" class="text-[#FF0000] ">
                                Late
                            </span>

                            <span *ngIf="item.deliveryPeriod ==='Later'" class="text-[#AC0003] ">
                                Late
                            </span>

                        </div>
                    </td>

                    <td class="px-6 py-4 text-sm text-gray-900 dark:text-gray-300 cursor-pointer"
                        (click)="navigateViewReply(item.processOrderId)">
                        <div class="flex items-center justify-center h-full ">
                            <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg" stroke="">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
                                        stroke="#415CFF" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                    </path>
                                </g>
                            </svg>
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>

    </div>

</div>


<div *ngIf="!isLoading && !listView" class="w-full min-h-screen">

    <p (click)="goBack()"
        class="flex items-center gap-2 w-fit text-sm text-[#5A5874] dark:text-gray-300 cursor-pointer mb-4 hover:text-[#292929] dark:hover:text-white">
        <i class="fa-solid fa-arrow-left"></i>
        <span class="underline">Go Back</span>
    </p>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
        <p class="text-[#494949] my-6 dark:text-white">---No order found--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

    <div *ngIf="hasData">

        <!-- Order info bar -->
        <div
            class="flex items-center bg-white dark:bg-[#1D1D1F] border-[1px] border-[#828282] rounded-xl px-6 py-4 mb-6">
            <div class="pr-6 flex-shrink-0">
                <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">Order ID :</p>
                <p class="font-medium text-lg text-[#000000] dark:text-textDark">{{ processOrder.invNo }}</p>
            </div>

            <div class="w-px self-stretch bg-[#828282] mx-6"></div>

            <div class="flex-1 flex items-center justify-between gap-4">
                <div>
                    <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">Type :</p>
                    <p class="font-medium text-[#000000] dark:text-textDark">{{ processOrder.delivaryMethod }}</p>
                </div>
                <div>
                    <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">Scheduled Date :</p>
                    <p class="font-medium text-[#000000] dark:text-textDark">{{ getOrdinalDay(processOrder.sheduleDate)
                        }} {{ processOrder.sheduleDate | date:'MMMM y' }}</p>
                </div>
                <div>
                    <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">Time Slot :</p>
                    <p class="font-medium text-[#000000] dark:text-textDark">{{ processOrder.sheduleTime }}</p>
                </div>
                <div>
                    <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">QC Done By :</p>
                    <p class="font-medium text-[#000000] dark:text-textDark">{{ processOrder.qcDoneBy }}</p>
                </div>
                <div>
                    <p class="text-sm text-[#7F7F7F] dark:text-gray-400 mb-1">Out Time :</p>
                    <p class="font-medium text-[#000000] dark:text-textDark">{{ processOrder.packTime | date:'hh:mm a'
                        }} on {{ getOrdinalDay(processOrder.packTime) }} {{ processOrder.packTime | date:'MMMM y' }}</p>
                </div>
            </div>
        </div>

        <!-- Item packs + Order journey -->
        <div class="flex flex-col lg:flex-row items-start gap-6">

            <div
                class="flex-1 w-full min-w-0 flex flex-col gap-6 lg:max-h-[calc(100vh-260px)] lg:overflow-y-auto lg:pr-2">
                <div *ngFor="let pack of processOrder.packages">


                    <!-- Create one table for each packageQty -->
                    <div *ngFor="let packageNumber of getPackageNumbers(pack.packageQty); let i = index"
                        class="mb-4">

                    <!-- Package heading -->
                    <p class="text-[#415CFF] text-sm font-medium mb-2">
                        {{ pack.packageName }}
                        ({{ pack.items.length < 10 ? ('0' + pack.items.length) : pack.items.length }})
                    </p>

                        <div class="overflow-hidden border border-gray-100 dark:border-[#202021] rounded-lg">

                            <table class="w-full divide-y-2">

                                <thead
                                    class="text-gray-700 bg-[#F7F8FB] dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">

                                    <tr>
                                        <th
                                            class="px-4 py-2 w-[40%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                            Item Name
                                        </th>

                                        <th
                                            class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                            Qty
                                        </th>

                                        <th
                                            class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                            Packed By
                                        </th>

                                        <th
                                            class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                            Time
                                        </th>
                                    </tr>

                                </thead>

                                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">

                                    <tr *ngFor="let item of pack.items">

                                        <td class="px-4 py-3 ">
                                            <div class="flex items-center gap-3">

                                                <img
                                                    [src]="item.image"
                                                    [alt]="item.productName"
                                                    class="w-8 h-8 rounded-full object-cover flex-shrink-0" />

                                                <span
                                                    class="text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                                    {{ item.productName }}
                                                </span>

                                            </div>
                                        </td>

                                        <td
                                            class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                            {{ item.qty }}kg
                                        </td>

                                        <td
                                            class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                            {{ item.packedByOfficer || "----" }}
                                        </td>

                                        <td
                                            class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                            {{ item.packingTime }}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

                <div *ngIf="processOrder.additionalItems?.length">
                    <p class="text-[#415CFF] text-sm font-medium mb-2">
                        Ala Carte Items
                        ({{ processOrder.additionalItems.length < 10 ? ('0' + processOrder.additionalItems.length) :
                            processOrder.additionalItems.length }}) </p>

                            <div class="overflow-hidden border border-gray-100 dark:border-[#202021] rounded-lg">
                                <table class="w-full divide-y-2">
                                    <thead
                                        class="text-gray-700 bg-[#F7F8FB] dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                                        <tr>
                                            <th
                                                class="px-4 py-2 w-[40%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                                Item
                                                Name</th>
                                            <th
                                                class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                                Qty
                                            </th>
                                            <th
                                                class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                                Packed By</th>
                                            <th
                                                class="px-4 py-2 w-[20%] text-left text-sm font-[400] text-[#4B5563] dark:text-white">
                                                Time
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                                        <tr *ngFor="let item of processOrder.additionalItems">
                                            <td class="px-4 py-3">
                                                <div class="flex items-center gap-3">
                                                    <img [src]="item.image" [alt]="item.productName"
                                                        class="w-8 h-8 rounded-full object-cover flex-shrink-0" />
                                                    <span class="text-[#000000] font-[400]  dark:text-[#C5C5C5]">{{
                                                        item.productName }}</span>
                                                </div>
                                            </td>
                                            <td class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                                {{ item.qty }}{{ item.unit }}
                                            </td>
                                            <td class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                                {{ item.packedByOfficer || "----" }}
                                            </td>
                                            <td class="px-4 py-3 text-[#000000] font-[400] dark:text-[#C5C5C5]">
                                                {{ item.packingTime }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                </div>
            </div>

            <div class="w-full lg:w-80 flex-shrink-0 lg:mt-7 lg:sticky lg:top-4">
                <div class="border-[1px] border-[#828282] rounded-xl px-5 py-4 dark:bg-[#1D1D1F]">
                    <p class="text-[#000000] font-[600] mb-4">Order Journey</p>

                    <div class="flex flex-col gap-4">
                        <div>
                            <p class="text-sm font-[400] text-[#7F7F7F] dark:text-gray-400 mb-1">QR Printed :</p>
                            <p class="font-[500] text-[#000000] dark:text-textDark">
                                {{processOrder.qrPrintBy }} by {{ processOrder.qrPrintTime | date:'hh:mm a' }} on {{
                                getOrdinalDay(processOrder.qrPrintTime) }} {{ processOrder.qrPrintTime | date:'MMMM y'
                                }}
                            </p>
                        </div>
                        <div>
                            <p class="text-sm font-[400] text-[#7F7F7F] dark:text-gray-400 mb-1">QC Done :</p>
                            <p class="font-[500] text-[#000000] dark:text-textDark">
                                {{ processOrder.qcDoneBy }} by {{ processOrder.packTime | date:'hh:mm a' }} on {{
                                getOrdinalDay(processOrder.packTime) }} {{ processOrder.packTime | date:'MMMM y' }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
